import MockAdapter from "axios-mock-adapter";

export const MockChatApi = (mock: MockAdapter) => {
  mock.onPost("").reply(204);
  mock.onDelete("").reply(204);
};
